var map = {
	"./admin/reducer.js": 421,
	"./album/reducer.js": 433,
	"./announcement/reducer.js": 434,
	"./class/reducer.js": 435,
	"./customer/reducer.js": 436,
	"./homework/reducer.js": 437,
	"./organization/reducer.js": 438,
	"./posts/reducer.js": 439,
	"./resource/reducer.js": 440,
	"./school/reducer.js": 760,
	"./sessions/reducer.js": 441,
	"./teacher/reducer.js": 442,
	"./user/reducer.js": 443
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 420;